// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TjwUZN{display:flex;flex-direction:column;justify-content:center;align-items:center}.desktop .TjwUZN{height:500px}.mobile .TjwUZN{height:360px}.desktop .FHSGxs{width:63px}.mobile .FHSGxs{width:48px}.MpGu5D{text-align:center}.desktop .boJB4e{position:absolute;left:36px;top:20px}.mobile .boJB4e{position:absolute;left:18px;top:20px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorWrapper": `TjwUZN`,
	"errorIcon": `FHSGxs`,
	"errorTitle": `MpGu5D`,
	"backButtonLayout": `boJB4e`
};
export default ___CSS_LOADER_EXPORT___;
